// extracted by mini-css-extract-plugin
module.exports = {"noEnoughInfoText":"ConsumesChart_noEnoughInfoText__1TSVl","chartContainer":"ConsumesChart_chartContainer__2Rcbc"};